import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { ConsentCheckboxState } from '../../../../utilities/marketing-consent';

export type WelcomePageContextProps = {
  privacyPolicyText?: string;
  setPrivacyPolicyText: (text: string) => void;
  marketingConsent?: ConsentCheckboxState;
  setMarketingConsent: (state: ConsentCheckboxState) => void;
};

export const WelcomePageContext = createContext<WelcomePageContextProps | null>(null);

export const useWelcomePageContext = (): WelcomePageContextProps => {
  const context = useContext(WelcomePageContext);

  if (!context) {
    throw new Error('useWelcomePageContext must be used within a WelcomePageContextProvider');
  }

  return context;
};

type WelcomePageProviderProps = {
  children: ReactNode;
};

export const WelcomePageProvider = ({ children }: WelcomePageProviderProps) => {
  const [privacyPolicyText, setPrivacyPolicyText] = useState<undefined | string>();
  const [marketingConsent, setMarketingConsent] = useState<ConsentCheckboxState>({
    state: 'not_shown',
  });

  const state = useMemo(
    (): WelcomePageContextProps => ({
      privacyPolicyText,
      setPrivacyPolicyText,
      marketingConsent,
      setMarketingConsent,
    }),
    [marketingConsent, privacyPolicyText]
  );

  return <WelcomePageContext.Provider value={state}>{children}</WelcomePageContext.Provider>;
};
